module.exports = __webpack_public_path__ + "static/media/japGreyNew.9cce0f67.png";